﻿import * as LogService from '../core/services/logservice/log.service';
import * as HttpDataServiceBase from '../core/httpdataservicebase';
import * as MessageBarService from '../core/services/messageBarService/messageBar.service';
import * as Model from '../models/models';
import IAppSettings from '../../iApp.settings';
import * as _ from 'lodash';

export class QuestionResponseRepository extends HttpDataServiceBase.DataServiceBase<Model.IQuestionResponse> {
    static $inject = ['$q', '$http', 'logService', 'appSettings', 'messageBarService'];
    constructor($q: ng.IQService, $http: ng.IHttpService, logger: LogService.ILogService, appSettings: IAppSettings, messageBarService: MessageBarService.MessageBarService) {
        super($q, $http, logger, messageBarService, appSettings.apiPath + '/questionresponses');

        this.appSettings = appSettings;
    }

    private appSettings: IAppSettings;

    public getQuestionResponsesBySearch(questionResponseSearch: Model.IQuestionResponseSearch, createMissingResponses?: boolean): ng.IPromise<any> {
        const url = `${this.appSettings.apiPath}/questionresponses/search`;

        const httpResultPromise: ng.IPromise<any> = this.$http.post(url, questionResponseSearch)
            .then((response: ng.IHttpPromiseCallbackArg<Model.IQuestionResponse[]>) => this.successHandler(response))
            .catch((error: ng.IHttpPromiseCallbackArg<any>) => this.errorHandler(error));

        if (createMissingResponses) 
            return httpResultPromise.then((responses: Model.IQuestionResponse[]) => this.addMissingResponses(responses, questionResponseSearch));
        

        return httpResultPromise;
    }

    private addMissingResponses = (responses: Model.IQuestionResponse[], search: Model.IQuestionResponseSearch): ng.IPromise<Model.IQuestionResponse[]> => {
        let missing: string[] = _.differenceWith(search.questionIds, responses, (e: string, r: Model.IQuestionResponse) => r.questionId === e);
        if (!responses)
            responses = [];

        for (let missingId of missing) {
            let response = { questionId: missingId, submissionId: search.submissionId } as Model.IQuestionResponse;
            responses.push(response);
        }
        return this.$q.when(responses);
    }

    public saveQuestionResponses(questionResponses: Model.IQuestionResponse[]): ng.IPromise<any> {
        const url = `${this.appSettings.apiPath}/questionresponses`;

        return this.$http.post(url, questionResponses)
            .then((response: ng.IHttpPromiseCallbackArg<Model.IQuestionResponse[]>) => this.successHandler(response))
            .catch((error: ng.IHttpPromiseCallbackArg<any>) => this.errorHandler(error));
    }

    public deleteCanceledCoverageQuestionResponse(submissionId: string): ng.IPromise<any> {
        const url = `${this.appSettings.apiPath}/canceledcoverage/${submissionId}`;

        return this.$http.delete(url)
            .then((response: ng.IHttpPromiseCallbackArg<Model.IQuestionResponse[]>) => this.successHandler(response))
            .catch((error: ng.IHttpPromiseCallbackArg<any>) => this.errorHandler(error));
    }    
}